import axios from '@axios'
import i18n from '@/libs/i18n'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        // Busca dados de status da frota de um endpoint real
        fetchFleetStatus(ctx, filters) {

            const queryParams = {
                id: filters.customerId, // Parâmetro obrigatório
                AssetModelId: filters.assetModelId,
                AssetManufacturerId: filters.assetManufacturerId,
                AssetTypeId: filters.assetTypeId,
                GroupId: filters.groupId,
            };


            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/queries/fleet/fleetsummaryreport`, {params: queryParams})
                    .then(response => {
                        // Adaptando a resposta da API para o formato esperado pelo componente
                        const apiResponse = response.data;
                        resolve({
                            data: {
                                highUsage: apiResponse.workingAssetCount || 0,
                                lowUsage: apiResponse.nonWorkingAssetCount || 0,
                                inactive: apiResponse.withoutConnectionAssetCount || 0,
                                // Dados adicionais disponíveis na API
                                assetsWithFailures: apiResponse.withFailureAssetCount || 0,
                                totalAssets: apiResponse.totalAssetCount || 0
                            }
                        })
                    })
                    .catch(error => reject(error))
            })
        },

        // Função não mais necessária, mantida para compatibilidade
        fetchAssetsWithFailures(ctx, {customerId, startDate, endDate}) {
            return new Promise((resolve) => {
                resolve({
                    data: {
                        count: 0
                    }
                })
            })
        },

        // Busca dados para o top 10 ativos com maior consumo de combustível
        fetchTopConsumptionAssets(ctx, filters) {
            const queryParams = {
                CustomerId: filters.customerId,
                DayStart: filters.startDate,
                DayEnd: filters.endDate,
                AssetModelId: filters.assetModelId,
                AssetManufacturerId: filters.assetManufacturerId,
                AssetTypeId: filters.assetTypeId,
                GroupId: filters.groupId,
            };
            
            const limit = filters.limit || 10;
            
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/queries/telemetry/averagefuelconsumptionreport`, {params: queryParams})
                    .then(response => {
                        // Transformar a resposta da API para o formato esperado pelo componente
                        const items = response.data && response.data.items ? response.data.items : [];
                        const formattedData = items
                            .slice(0, limit)
                            .map(item => ({
                                assetId: item.assetDescriptor || i18n.t('Unidentified'),
                                value: parseFloat(item.average.toFixed(2))
                            }));

                        resolve({
                            data: formattedData
                        });
                    })
                    .catch(error => reject(error))
            })
        },

        // Busca dados para o top 10 ativos com maior tempo em uso severo
        fetchTopSevereUseAssets(ctx, filters) {
            const queryParams = {
                CustomerId: filters.customerId,
                DayStart: filters.startDate,
                DayEnd: filters.endDate,
                AssetModelId: filters.assetModelId,
                AssetManufacturerId: filters.assetManufacturerId,
                AssetTypeId: filters.assetTypeId,
                GroupId: filters.groupId,
            };
            
            const limit = filters.limit || 10;
            
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/queries/telemetry/severeusereport`, {params: queryParams})
                    .then(response => {
                        // Transformar a resposta da API para o formato esperado pelo componente
                        const items = response.data && response.data.items ? response.data.items : [];
                        const formattedData = items
                            .slice(0, limit)
                            .map(item => ({
                                assetId: item.assetDescriptor || i18n.t('Unidentified'),
                                value: item.totalMinutes
                            }));

                        resolve({
                            data: formattedData
                        });
                    })
                    .catch(error => reject(error))
            })
        },

        // Busca dados para o top 10 ativos com maior tempo em uso ocioso
        fetchTopIdleUseAssets(ctx, filters) {
            const queryParams = {
                CustomerId: filters.customerId,
                DayStart: filters.startDate,
                DayEnd: filters.endDate,
                AssetModelId: filters.assetModelId,
                AssetManufacturerId: filters.assetManufacturerId,
                AssetTypeId: filters.assetTypeId,
                GroupId: filters.groupId,
            };
            
            const limit = filters.limit || 10;
            
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/queries/telemetry/iddleusereport`, {params: queryParams})
                    .then(response => {
                        // Transformar a resposta da API para o formato esperado pelo componente
                        const items = response.data && response.data.items ? response.data.items : [];
                        const formattedData = items
                            .slice(0, limit)
                            .map(item => ({
                                assetId: item.assetDescriptor || i18n.t('Unidentified'),
                                value: item.totalMinutes
                            }));

                        resolve({
                            data: formattedData
                        });
                    })
                    .catch(error => reject(error))
            })
        },

        // Busca dados para o top 10 ativos com maior número de falhas
        fetchTopFailuresAssets(ctx, filters) {
            const queryParams = {
                CustomerId: filters.customerId,
                DayStart: filters.startDate,
                DayEnd: filters.endDate,
                AssetModelId: filters.assetModelId,
                AssetManufacturerId: filters.assetManufacturerId,
                AssetTypeId: filters.assetTypeId,
                GroupId: filters.groupId,
            };
            
            const limit = filters.limit || 10;
            
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/queries/telemetry/failurecountreport`, {params: queryParams})
                    .then(response => {
                        // Transformar a resposta da API para o formato esperado pelo componente
                        const items = response.data && response.data.items ? response.data.items : [];
                        const formattedData = items
                            .slice(0, limit)
                            .map(item => ({
                                assetId: item.assetDescriptor || i18n.t('Unidentified'),
                                value: item.totalFailures
                            }));

                        resolve({
                            data: formattedData
                        });
                    })
                    .catch(error => reject(error))
            })
        },
        fetchAssetsCountReport(ctx, filters) {
            const queryParams = {
                CustomerId: filters.customerId,
                AssetModelId: filters.assetModelId,
                AssetManufacturerId: filters.assetManufacturerId,
                AssetTypeId: filters.assetTypeId,
                GroupId: filters.groupId,
            };
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/queries/telemetry/AssetsCountReport`, {params: queryParams})
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }
    }
} 